import script from "./TabPage.vue?vue&type=script&setup=true&lang=js"
export * from "./TabPage.vue?vue&type=script&setup=true&lang=js"

import "./TabPage.vue?vue&type=style&index=0&id=21332338&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21332338"]])

export default __exports__